import { render, staticRenderFns } from "./ViewDocumentRoles.vue?vue&type=template&id=b2e71944&"
import script from "./ViewDocumentRoles.vue?vue&type=script&lang=js&"
export * from "./ViewDocumentRoles.vue?vue&type=script&lang=js&"
import style0 from "./ViewDocumentRoles.vue?vue&type=style&index=0&id=b2e71944&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports